import { Helmet } from "react-helmet-async"
import { Lightbulb, Target, Scale } from "lucide-react"

export default function VisionMission() {
  return (
    <>
      <Helmet>
        <title>Vision & Mission - Pranaam Hospitals</title>
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <div className="relative h-64 md:h-96 bg-gradient-to-r from-brand-nickel to-brand-teal">
          <img src="/images/HealthcareSpectrum.png" alt="Healthcare" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white text-center px-4">Vision & Mission</h1>
          </div>
        </div>

        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            
            <div className="grid md:grid-cols-3 gap-8">
              
              {/* Vision */}
              <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full border-4 border-red-600 flex items-center justify-center">
                    <Lightbulb className="w-10 h-10 md:w-12 md:h-12 text-red-600" />
                  </div>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center">VISION</h2>
                <p className="text-gray-700 leading-relaxed text-center">
                  To be the go-to destination for excellence and innovation in healthcare.
                </p>
              </div>

              {/* Mission */}
              <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full border-4 border-red-600 flex items-center justify-center">
                    <Target className="w-10 h-10 md:w-12 md:h-12 text-red-600" />
                  </div>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center">MISSION</h2>
                <p className="text-gray-700 leading-relaxed text-center">
                  Nothing is more rewarding than the heart-felt gratitude from our patients and their loves when we help restore their health and live better lives. This helps us set the bar even higher for ourselves by delivering compassionate and seamless care at all times.
                </p>
              </div>

              {/* Values */}
              <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full border-4 border-red-600 flex items-center justify-center">
                    <Scale className="w-10 h-10 md:w-12 md:h-12 text-red-600" />
                  </div>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center">VALUES</h2>
                <p className="text-gray-700 mb-4 text-center">
                  The core values ingrained deep in our system, drives us to offer the best healthcare services through:
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Trust</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Commitment</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Compassion</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Excellence</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Integrity</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Respect</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Teamwork</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
